export interface SearchHit { type: 'incident' | 'problem' | 'change' | 'article' | 'ci' | 'user'; id: string; title: string; desc: string; route: string }

/** Exact id, then id fragment, then title, then description; capped at `max`. */
export function rankResults(hits: SearchHit[], q: string, max = 12): SearchHit[] {
  const n = q.trim().toLowerCase();
  if (!n) return [];
  const score = (x: SearchHit) =>
    (x.id.toLowerCase() === n ? 1000 : 0) + (x.id.toLowerCase().includes(n) ? 100 : 0) + (x.title.toLowerCase().includes(n) ? 50 : 0) + (x.desc.toLowerCase().includes(n) ? 10 : 0);
  return hits.map((x) => ({ x, s: score(x) })).filter((r) => r.s > 0).sort((a, b) => b.s - a.s).slice(0, max).map((r) => r.x);
}
